import BrownRiceProduct from 'models/BrownRiceProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BrownRicePackage from './BrownRicePackage'

const productOptions = {
  packagingInfo: <BrownRicePackage />,
  productTitle: 'Brown Rice',
  model: BrownRiceProduct,
  validCategories: ['16'],
  validSubCategories: ['003'],
}

const BrownRice = () => <ProductForm product={productOptions} />

export default BrownRice

export const getBrownRicePackage = newProduct => {
  const newBrownRicePackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Brown Rice',
    CookingType: newProduct.CookingType,
    GrainSize: newProduct.GrainSize,
    GrainLength: newProduct.GrainLength,
    OatVariety:
      newProduct.OatVariety === 'Other'
        ? newProduct.otherType
        : newProduct.OatVariety,
  }
  return newBrownRicePackage
}
export const updateBrownRicePackage = newProduct => {
  const newBrownRicePackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Brown Rice',
    CookingType: newProduct.CookingType,
    GrainSize: newProduct.GrainSize,
    GrainLength: newProduct.GrainLength,
    OatVariety:
      newProduct.OatVariety === 'Other'
        ? newProduct.otherType
        : newProduct.OatVariety,
  }
  return newBrownRicePackage
}
